export default function getActionImageBorderClass(imageSrc) {
  const imageName =
    String(imageSrc || '')
      .split('/')
      .pop() || ''
  const normalizedImageName = imageName.toLowerCase()

  if (normalizedImageName.includes('blank') || normalizedImageName.includes('pending')) {
    return 'bb-img-no-border'
  }

  return 'bb-img-norm-border'
}
